import React, { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import toast from "react-hot-toast";
import _ from "lodash";

import api from "../../api";

import SearchField from "../../commons/SearchField";

const TrainingCourseSearchField = ({ onResults, onCancel }) => {

  const queryParameters = new URLSearchParams(window.location.search);
  const initialSearchTerm = queryParameters.get("search") || "";

  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(initialSearchTerm);
  const [searchTermDebounced] = useDebounce(searchTerm, 1000);

  useEffect(() => {
      if (_.isEmpty(searchTermDebounced)) {
        onCancel && onCancel();
        return;
      }

      search();
  }, [searchTermDebounced]);

  const search = () => {
    if (_.isEmpty(searchTermDebounced)) return;

    setLoading(true);

    api.get(`/training-courses?search=${searchTermDebounced}`)
      .then(res => {
        console.log(res);

        onResults && onResults(res.data.training_courses)

        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch(err => {
        if (err.response && err.response.data && err.response.data.message) {
          toast.error(<b>{err.response.data.message}</b>);
        } else {
          toast.error(<b>{I18n.t("common.errors.unexpected_error")}</b>);
        }
        setLoading(false);
        console.error(err);
      });
  }

  return (
    <SearchField
      loading={loading}
      value={searchTerm}
      onChange={setSearchTerm}
    />
  )
}

export default TrainingCourseSearchField;
